// Create Group Order (admin)
export const CREATE_GROUP_ORDER_REQUEST = "CREATE_GROUP_ORDER_REQUEST";
export const CREATE_GROUP_ORDER_SUCCESS = "CREATE_GROUP_ORDER_SUCCESS";
export const CREATE_GROUP_ORDER_FAILURE = "CREATE_GROUP_ORDER_FAILURE";
export const CREATE_GROUP_ORDER_RESET = "CREATE_GROUP_ORDER_RESET";

// Fetch Group Orders (admin)
export const FETCH_GROUP_ORDERS_REQUEST = "FETCH_GROUP_ORDERS_REQUEST";
export const FETCH_GROUP_ORDERS_SUCCESS = "FETCH_GROUP_ORDERS_SUCCESS";
export const FETCH_GROUP_ORDERS_FAILURE = "FETCH_GROUP_ORDERS_FAILURE";

// Fetch Group Order Details (admin)
export const FETCH_GROUP_ORDER_DETAILS_REQUEST = "FETCH_GROUP_ORDER_DETAILS_REQUEST";
export const FETCH_GROUP_ORDER_DETAILS_SUCCESS = "FETCH_GROUP_ORDER_DETAILS_SUCCESS";
export const FETCH_GROUP_ORDER_DETAILS_FAILURE = "FETCH_GROUP_ORDER_DETAILS_FAILURE";

// Fetch Group Order (public)
export const FETCH_GROUP_ORDER_REQUEST = "FETCH_GROUP_ORDER_REQUEST";
export const FETCH_GROUP_ORDER_SUCCESS = "FETCH_GROUP_ORDER_SUCCESS";
export const FETCH_GROUP_ORDER_FAILURE = "FETCH_GROUP_ORDER_FAILURE";

// Create Group Payment (public)
export const CREATE_GROUP_PAYMENT_REQUEST = "CREATE_GROUP_PAYMENT_REQUEST";
export const CREATE_GROUP_PAYMENT_SUCCESS = "CREATE_GROUP_PAYMENT_SUCCESS";
export const CREATE_GROUP_PAYMENT_FAILURE = "CREATE_GROUP_PAYMENT_FAILURE";

// Confirm Group Payment (public)
export const CONFIRM_GROUP_PAYMENT_REQUEST = "CONFIRM_GROUP_PAYMENT_REQUEST";
export const CONFIRM_GROUP_PAYMENT_SUCCESS = "CONFIRM_GROUP_PAYMENT_SUCCESS";
export const CONFIRM_GROUP_PAYMENT_FAILURE = "CONFIRM_GROUP_PAYMENT_FAILURE";

// Fetch My Group Orders (coordinator)
export const FETCH_MY_GROUP_ORDERS_REQUEST = "FETCH_MY_GROUP_ORDERS_REQUEST";
export const FETCH_MY_GROUP_ORDERS_SUCCESS = "FETCH_MY_GROUP_ORDERS_SUCCESS";
export const FETCH_MY_GROUP_ORDERS_FAILURE = "FETCH_MY_GROUP_ORDERS_FAILURE";

// Redeem Group Code (student)
export const REDEEM_GROUP_CODE_REQUEST = "REDEEM_GROUP_CODE_REQUEST";
export const REDEEM_GROUP_CODE_SUCCESS = "REDEEM_GROUP_CODE_SUCCESS";
export const REDEEM_GROUP_CODE_FAILURE = "REDEEM_GROUP_CODE_FAILURE";
export const REDEEM_GROUP_CODE_RESET = "REDEEM_GROUP_CODE_RESET";

// Validate Group Code (public)
export const VALIDATE_GROUP_CODE_REQUEST = "VALIDATE_GROUP_CODE_REQUEST";
export const VALIDATE_GROUP_CODE_SUCCESS = "VALIDATE_GROUP_CODE_SUCCESS";
export const VALIDATE_GROUP_CODE_FAILURE = "VALIDATE_GROUP_CODE_FAILURE";
export const VALIDATE_GROUP_CODE_RESET = "VALIDATE_GROUP_CODE_RESET";

// Create Individual Code Payment (authenticated)
export const CREATE_INDIVIDUAL_CODE_PAYMENT_REQUEST = "CREATE_INDIVIDUAL_CODE_PAYMENT_REQUEST";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_SUCCESS = "CREATE_INDIVIDUAL_CODE_PAYMENT_SUCCESS";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_FAILURE = "CREATE_INDIVIDUAL_CODE_PAYMENT_FAILURE";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_RESET = "CREATE_INDIVIDUAL_CODE_PAYMENT_RESET";

// Confirm Individual Code Payment (authenticated)
export const CONFIRM_INDIVIDUAL_CODE_PAYMENT_REQUEST = "CONFIRM_INDIVIDUAL_CODE_PAYMENT_REQUEST";
export const CONFIRM_INDIVIDUAL_CODE_PAYMENT_SUCCESS = "CONFIRM_INDIVIDUAL_CODE_PAYMENT_SUCCESS";
export const CONFIRM_INDIVIDUAL_CODE_PAYMENT_FAILURE = "CONFIRM_INDIVIDUAL_CODE_PAYMENT_FAILURE";
export const CONFIRM_INDIVIDUAL_CODE_PAYMENT_RESET = "CONFIRM_INDIVIDUAL_CODE_PAYMENT_RESET";

// Create Individual Code Payment Public (registration)
export const CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_REQUEST = "CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_REQUEST";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_SUCCESS = "CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_SUCCESS";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_FAILURE = "CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_FAILURE";
export const CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_RESET = "CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_RESET";

// Activate Group Order Paid Codes (admin)
export const ACTIVATE_PAID_CODES_REQUEST = "ACTIVATE_PAID_CODES_REQUEST";
export const ACTIVATE_PAID_CODES_SUCCESS = "ACTIVATE_PAID_CODES_SUCCESS";
export const ACTIVATE_PAID_CODES_FAILURE = "ACTIVATE_PAID_CODES_FAILURE";
export const ACTIVATE_PAID_CODES_RESET = "ACTIVATE_PAID_CODES_RESET";

// Approve Group Order Request (admin)
export const APPROVE_GROUP_ORDER_REQUEST_REQUEST = "APPROVE_GROUP_ORDER_REQUEST_REQUEST";
export const APPROVE_GROUP_ORDER_REQUEST_SUCCESS = "APPROVE_GROUP_ORDER_REQUEST_SUCCESS";
export const APPROVE_GROUP_ORDER_REQUEST_FAILURE = "APPROVE_GROUP_ORDER_REQUEST_FAILURE";
export const APPROVE_GROUP_ORDER_REQUEST_RESET = "APPROVE_GROUP_ORDER_REQUEST_RESET";

// Reject Group Order Request (admin)
export const REJECT_GROUP_ORDER_REQUEST_REQUEST = "REJECT_GROUP_ORDER_REQUEST_REQUEST";
export const REJECT_GROUP_ORDER_REQUEST_SUCCESS = "REJECT_GROUP_ORDER_REQUEST_SUCCESS";
export const REJECT_GROUP_ORDER_REQUEST_FAILURE = "REJECT_GROUP_ORDER_REQUEST_FAILURE";
export const REJECT_GROUP_ORDER_REQUEST_RESET = "REJECT_GROUP_ORDER_REQUEST_RESET";
